import React from 'react';
import store from 'storejs'
import { withStyles } from 'material-ui/styles';
import MenuItem from 'material-ui/Menu/MenuItem';
import TextField from 'material-ui/TextField';
import { FormControl, FormGroup, FormControlLabel, FormLabel, FormHelperText } from 'material-ui/Form';
import Checkbox from 'material-ui/Checkbox';
import Input, { InputLabel } from 'material-ui/Input';
import Select from 'material-ui/Select';

import OPTIONS from '../../constants/settingOptions'
import { TEMPLATES } from '../../constants/templates'
import Preview from '../preview'

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 145,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 100,
    },
    menu: {
        width: 200,
    },
    fullWidth: {
        width: `90%`,
        margin: theme.spacing.unit,
    }
});

class TextFields extends React.Component {
    state = {
        template: 'Master',
        displays: {
            authors: true,
            title: true,
            journal: true,
            year: true,
            volume: true,
            page: true
        },
        abbrevs: {
            familyName: false,
            givenName: true,
            journal: true,
        },
        styles: {
            authors: OPTIONS.FONT_STYLE.NORMAL,
            title: OPTIONS.FONT_STYLE.NORMAL,
            journal: OPTIONS.FONT_STYLE.ITALIC,
            year: OPTIONS.FONT_STYLE.BOLD,
            volume: OPTIONS.FONT_STYLE.ITALIC,
            page: OPTIONS.FONT_STYLE.NORMAL,
        },
        conjunctions: {
            betweenFamilyAndGiven: ' ',
            betweenGivenName: ' ',
            betweenAuthors: '; ',
            afterAuthors: '. ',
            afterTitle: '. ',
            afterJournal: ' ',
            afterYear: ', ',
            afterVolume: ', ',
            afterPage: '. ',
        },
        positions: {
            authors: 1,
            title: 2,
            journal: 3,
            year: 4,
            volume: 5,
            page: 6
        },
        misc: {
            givenBeforeFamily: 0, // select 里出现 false 会报错
            etalThreshold: 20,
            useAndBetweenLastTwo: false,
            titleStyle: OPTIONS.TITLE_STYLE.CAP_ALL_WORDS
        }
    };

    displays = [
        ['authors', '作者'],
        ['title', '标题'],
        ['journal', '杂志'],
        ['year', '年份'],
        ['volume', '卷数'],
        ['page', '页码'],
    ]
    abbrevs = [
        ['familyName', '姓氏'],
        ['givenName', '名字'],
        ['journal', '杂志']
    ]
    conjunctions = [
        ['betweenFamilyAndGiven', '单名作者的姓名中间', 'Kong→?←F. Z.'],
        ['betweenGivenName', '单名作者的名字中间', 'Kong F.→?←Z.'],
        ['betweenAuthors', '多名作者的名字中间', 'Li B.→?←Kong F. Z.'],
        ['afterAuthors', '所有作者之后', '...; Hawking. S. W.→?←'],
        ['afterTitle', '标题之后', 'Title→?←'],
        ['afterJournal', '杂志名之后', 'Nat. Chem.→?←2018'],
        ['afterYear', '年份之后', '2018→?←7'],
        ['afterVolume', '卷数之后', '7→?←249-251'],
        ['afterPage', '页码之后', '249-251→?←']
    ]
    styles = [
        ['authors', '作者'],
        ['title', '标题'],
        ['journal', '杂志'],
        ['year', '年份'],
        ['volume', '卷数'],
        ['page', '页码'],
    ]
    positions = [
        ['authors', '作者'],
        ['title', '标题'],
        ['journal', '杂志'],
        ['year', '年份'],
        ['volume', '卷数'],
        ['page', '页码'],
    ]

    fireOptionChange = () => {
        const ev = new Event('optionChanged')
        window.dispatchEvent(ev);
    }

    handleChange = field => event => {
        this.fireOptionChange()
        const [category, name] = field.split('.')
        const element = event.target
        const value = element.type === 'checkbox'
            ? element.checked
            : element.value
        // 改模板
        if (category === 'template') {
            this.setState({
                template: value,
                ...TEMPLATES[value.toUpperCase()]
            }, () => {
                store.set('settings', this.state)
            })
            return
        }
        if (!name) {
            this.setState({
                template: 'custom',
                [category]: value,
            }, () => {
                store.set('settings', this.state)
            });
        } else {
            this.setState({
                template: 'custom',
                [category]: {
                    ...this.state[category],
                    [name]: value,
                }
            }, () => {
                store.set('settings', this.state)
            })
        }
    };

    componentWillMount() {
        const settings = store.get('settings')
        if (settings) {
            this.setState(store.get('settings'))
        }
    }

    componentDidMount() {
        const settings = store.get('settings')
        if (!settings) {
            store.set('settings', this.state)
        }
    }
    render() {
        const { classes } = this.props;

        return (

            <form>
                <FormControl id="preview_form_control" className={classes.fullWidth} component="fieldset">
                    <FormLabel>预览</FormLabel>
                    <Preview options={this.state} key="preview" />
                </FormControl>
                <FormControl id="template_form_control" className={classes.fullWidth} component="fieldset">
                    <FormLabel component="legend">模板</FormLabel>
                    <FormGroup>
                        <FormControl>
                            <Select
                                value={this.state.template}
                                onChange={this.handleChange('template')}
                                inputProps={{
                                    name: 'template',
                                    id: 'template'
                                }}
                            >
                                <MenuItem value="ACS">ACS</MenuItem>
                                <MenuItem value="Wiley">Wiley</MenuItem>
                                <MenuItem value="RSC">RSC</MenuItem>
                                <MenuItem value="Master">硕士毕业论文</MenuItem>
                                <MenuItem value="custom">自定义</MenuItem>
                            </Select>
                        </FormControl>
                    </FormGroup>
                </FormControl>
                <FormControl id="show_form_control" className={classes.formControl} component="fieldset">
                    <FormLabel component="legend">显示以下内容：</FormLabel>
                    <FormGroup row>
                        {this.displays.map(([key, label]) => {
                            return <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.displays[key]}
                                        onChange={this.handleChange(`displays.${key}`)}
                                        value={`displays.${key}`}
                                    />
                                }
                                label={label}
                                key={key}
                            />
                        })}
                    </FormGroup>
                </FormControl>
                <FormControl id="abbrev_form_control" className={classes.formControl} component="fieldset">
                    <FormLabel component="legend">使用缩写：</FormLabel>
                    <FormGroup row>
                        {this.abbrevs.map(([key, label]) => {
                            return <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.abbrevs[key]}
                                        onChange={this.handleChange(`abbrevs.${key}`)}
                                        value={`abbrevs.${key}`}
                                    />
                                }
                                label={label}
                                key={key}
                            />
                        })}
                    </FormGroup>
                </FormControl>
                <FormControl id="conjunction_form_control" className={classes.formControl} component="fieldset">
                    <FormLabel component="legend">连接符：（问号处填入的字符，注意空格）</FormLabel>
                    <FormGroup row>
                        {
                            this.conjunctions.map(([key, label, helperText]) => {
                                return <TextField
                                    id={key}
                                    key={key}
                                    label={label}
                                    className={classes.textField}
                                    value={this.state.conjunctions[key]}
                                    onChange={this.handleChange(`conjunctions.${key}`)}
                                    margin="normal"
                                    helperText={helperText}
                                />
                            })
                        }
                    </FormGroup>
                </FormControl>
                <FormControl id="style_form_control" className={classes.formControl} component="fieldset">
                    <FormLabel component="legend">样式设置：</FormLabel>
                    <FormGroup row>
                        {this.styles.map(([key, label]) => {
                            return <FormControl className={classes.formControl} key={key}>
                                <InputLabel htmlFor={`styles.${key}`}>{`${label}`}</InputLabel>
                                <Select
                                    value={this.state.styles[key]}
                                    onChange={this.handleChange(`styles.${key}`)}
                                    inputProps={{
                                        name: `styles.${key}`,
                                        id: `styles.${key}`,
                                    }}
                                >
                                    <MenuItem value={OPTIONS.FONT_STYLE.NORMAL}>正常</MenuItem>
                                    <MenuItem value={OPTIONS.FONT_STYLE.BOLD}><strong>粗体</strong></MenuItem>
                                    <MenuItem value={OPTIONS.FONT_STYLE.ITALIC}><em>斜体</em></MenuItem>
                                    <MenuItem value={OPTIONS.FONT_STYLE.BOLD_ITALIC}><strong><em>斜粗体</em></strong></MenuItem>
                                </Select>
                            </FormControl>
                        })}
                    </FormGroup>
                </FormControl>
                <FormControl id="position_form_control" className={classes.formControl} component="fieldset">
                    <FormLabel component="legend">顺序设置：</FormLabel>
                    <FormGroup row>
                        {this.positions.map(([key, label]) => {
                            return <FormControl className={classes.formControl} key={key}>
                                <InputLabel htmlFor={`positions.${key}`}>{`${label}`}</InputLabel>
                                <Select
                                    value={this.state.positions[key]}
                                    onChange={this.handleChange(`positions.${key}`)}
                                    inputProps={{
                                        name: `positions.${key}`,
                                        id: `positions.${key}`,
                                    }}
                                >
                                    {[1, 2, 3, 4, 5, 6].map((num) => {
                                        return <MenuItem value={num} key={num}>{num}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                        })}
                    </FormGroup>
                </FormControl>
                <FormControl id="misc_form_control" className={classes.formControl} component="fieldset">
                    <FormLabel component="legend">杂项设置：</FormLabel>
                    <FormGroup row>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor={`misc.givenBeforeFamily`}>姓名顺序</InputLabel>
                            <Select
                                value={this.state.misc.givenBeforeFamily}
                                onChange={this.handleChange(`misc.givenBeforeFamily`)}
                                inputProps={{
                                    name: `misc.givenBeforeFamily`,
                                    id: `misc.givenBeforeFamily`,
                                }}
                                displayEmpty
                            >
                                <MenuItem value={0}>姓在名前</MenuItem>
                                <MenuItem value={1}>名在姓前</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor={`misc.titleStyle`}>标题样式</InputLabel>
                            <Select
                                value={this.state.misc.titleStyle}
                                onChange={this.handleChange(`misc.titleStyle`)}
                                inputProps={{
                                    name: `misc.titleStyle`,
                                    id: `misc.titleStyle`,
                                }}
                                displayEmpty
                            >
                                <MenuItem value={OPTIONS.TITLE_STYLE.CAP_FIRST_WORD}>首字母大写</MenuItem>
                                <MenuItem value={OPTIONS.TITLE_STYLE.CAP_ALL_WORDS}>单词大写</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="etalThreshold">et al.阈值</InputLabel>
                            <Input
                                id="etalThreshold"
                                className={classes.textField}
                                value={this.state.misc.etalThreshold}
                                onChange={this.handleChange(`misc.etalThreshold`)}
                            />
                            <FormHelperText>作者超过多少个时显示et al</FormHelperText>
                        </FormControl>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.misc.useAndBetweenLastTwo}
                                    onChange={this.handleChange('misc.useAndBetweenLastTwo')}
                                    value="misc.useAndBetweenLastTwo"
                                />
                            }
                            label="最后两个作者之间使用and连接"
                        />
                    </FormGroup>
                </FormControl>
            </form>
        );
    }
}

export default withStyles(styles)(TextFields);


// WEBPACK FOOTER //
// ./src/components/modals/settings.js